export const cartKeyFactory = {
  all: [{ scope: 'cart' }] as const,
  detail: () => [{ ...cartKeyFactory.all[0], entity: 'detail' }] as const,
  itemCount: () =>
    [{ ...cartKeyFactory.all[0], entity: 'item-count' }] as const,
}
